import React, { useState, useEffect, useRef } from "react";
import img1 from './images/image1.jpg';
import img2 from './images/image2.jpg';
import img3 from './images/image3.jpg';
import img4 from './images/image4.jpg';
import img5 from './images/image5.jpg';
import img6 from './images/image6.jpg';
import img7 from './images/image7.jpg';
import img8 from './images/image8.jpg';
import img9 from './images/image9.jpg';
import img10 from './images/image10.jpg';
import img11 from './images/image11.jpg';
import img12 from './images/image12.jpg';
import img14 from './images/image14.jpg';
import crs1 from './images/crl1.jpg';
import crs2 from './images/crl2.jpg';
import crs3 from './images/crl3.jpg';
import crs5 from './images/crl5.jpg';
import './App.css';

// All components are defined within this single file to be self-contained.
// This is the main application component that renders the entire UI.
const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Use a useEffect hook to handle the scroll event.
  useEffect(() => {
    const handleScroll = () => {
      // Check if the user has scrolled down more than 50 pixels.
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Add the event listener when the component mounts.
    window.addEventListener('scroll', handleScroll);

    // Remove the event listener when the component unmounts to prevent memory leaks.
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen font-inter bg-gray-50">
      {/* Header Area */}
      <Header scrolled={scrolled} toggleMobileMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />

      {/* Body (Hero Section) */}
      <main className="flex-grow pt-32">
        <section
          id="home"
          className="h-[650px] flex items-center justify-center relative overflow-hidden" // Added 'relative' and 'overflow-hidden'
        >
          {/* This is the blurred background image */}
          <div
            className="absolute inset-0 bg-cover bg-center filter blur-sm" // Added 'absolute', 'inset-0', 'filter', and 'blur-sm'
            style={{
              backgroundImage: `url(${crs3})`,
            }}
          ></div>

          {/* This is your content on top of the blurred background */}
          <div className="relative bg-black bg-opacity-60 p-10 rounded-lg text-center text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Explore the World with Us
            </h2>
            <p className="mb-6">
              Discover a world of possibilities with Chezher 888 Travel & Tours Inc.
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-medium"
            >
              Book Now
            </button>
          </div>
        </section>
      </main>

      <Sections />
      {/* Booking Modal */}
      <BookingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      {/* Footer */}
      <Footer />
    </div>
  );
};

// Define the Header component
const Header = ({ scrolled, toggleMobileMenu }) => (
  <header
    className={`bg-white shadow-md fixed top-0 w-full z-10 transition-all duration-300 ${
      scrolled ? "py-2" : "py-10"
    }`}
  >
    <nav className="container mx-auto px-10 flex justify-between items-center">
          <div className="flex items-center">
            {/* Responsive Logo */}
            <img
              src="logo-picture.png"
              alt="Chezher 888 Travel & Tours Logo"
              className="h-10 w-14 md:h-14 md:w-20 mr-2 md:mr-3 flex-shrink-0 rounded-lg"
            />
            <div className="text-xl md:text-3xl font-bold text-gray-800">
              Chezher 888 Travel & Tours Inc.
            </div>
          </div>

      {/* Desktop Nav */}
      <div className="hidden md:flex space-x-6 text-xl">
        <a href="#home" className="text-black-600 hover:text-green-500">
          Home
        </a>
        <a href="#services" className="text-black-600 hover:text-green-500">
          Services
        </a>
        <a href="#about" className="text-black-600 hover:text-green-500">
          About
        </a>
        <a href="#contact" className="text-black-600 hover:text-green-500">
          Contact
        </a>
      </div>

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMobileMenu}
        className="md:hidden text-gray-600 hover:text-green-500"
      >
        <svg
          className="w-7 h-7"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>
    </nav>
  </header>
);

// Define the MobileMenu component
const MobileMenu = ({ isOpen, onClose }) => {
  return (
    <div
      className={`fixed inset-0 z-40 bg-white md:hidden transform transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <div className="flex justify-end p-6">
        <button onClick={onClose} className="text-gray-600 hover:text-green-500">
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <nav className="flex flex-col items-center space-y-8 text-2xl">
        <a href="#home" onClick={onClose} className="text-gray-600 hover:text-green-500">
          Home
        </a>
        <a href="#services" onClick={onClose} className="text-gray-600 hover:text-green-500">
          Services
        </a>
        <a href="#about" onClick={onClose} className="text-gray-600 hover:text-green-500">
          About
        </a>
        <a href="#contact" onClick={onClose} className="text-gray-600 hover:text-green-500">
          Contact
        </a>
      </nav>
    </div>
  );
};

// Define the services data. The image URLs have been updated to use public links for a working demo.
const servicesData = [
  {
    title: "Out of town Tours",
    description: "Find the best deals on flights to your dream destination.",
    imageUrl: img1,
    bgColor: "bg-teal-400",
    targetId: "business-tours", // 👈 add this
  },
  {
    title: "Business Tours",
    description: "Explore exciting and curated tour packages worldwide.",
    imageUrl: img2,
    bgColor: "bg-pink-400",
    targetId: "airport-transport",
  },
  {
    title: "Airport Transport",
    description: "Book unique local experiences for an unforgettable trip.",
    imageUrl: img3,
    bgColor: "bg-teal-400",
    targetId: "family-outings",
  },
  {
    title: "Family outings",
    description: "Book unique local experiences for an unforgettable trip.",
    imageUrl: img12,
    bgColor: "bg-pink-400",
    targetId: "company-outings",
  },
  {
    title: "Company outings and Teambuildings",
    description: "Book unique local experiences for an unforgettable trip.",
    imageUrl: img14,
    bgColor: "bg-teal-400",
    targetId: "events-seminars",
  },
  {
    title: "Events & Seminars",
    description: "Book unique local experiences for an unforgettable trip.",
    imageUrl: img6,
    bgColor: "bg-pink-400",
    targetId: "shuttle-services",
  },
  {
    title: "Shuttle Services",
    description: "Book unique local experiences for an unforgettable trip.",
    imageUrl: img5,
    bgColor: "bg-teal-400",
    targetId: "footer", // 👈 last one scrolls to footer or top
  },
];


// Define the Sections component
const Sections = () => (
  <>
    <section id="services" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6 text-center">
        <h3 className="text-5xl font-bold text-gray-800 mb-8">
          Our Services
        </h3>
        <div className="flex flex-col items-center gap-12">
          {servicesData.map((service, index) => (
            <div
              key={index}
              id={`service-${index}`} // 👈 give each section a unique id
              className={`flex flex-col md:flex-row w-full max-w-8xl rounded-lg overflow-hidden transition-transform duration-300 transform hover:scale-[1.01] shadow-xl
                ${index % 2 !== 0 ? "md:flex-row-reverse" : ""}`}
            >
              {/* Image Column */}
              <div
                className="w-full h-64 md:h-[500px] md:w-1/2 bg-cover bg-center"
                style={{ backgroundImage: `url(${service.imageUrl})` }}
              ></div>

              {/* Content Column with Overlap */}
              <div
                className={`w-full md:w-[50%] md:relative md:z-10 
                  flex items-center justify-center
                  ${index % 2 !== 0 ? "md:-mr-20" : "md:-ml-20"}`}
              >
                <div
                  className={`${service.bgColor} w-full h-80 p-10 flex flex-col justify-center text-left text-white`}
                >
                  <h4 className="text-3xl font-bold mb-4 leading-snug">
                    {service.title}
                  </h4>
                  <p className="mb-6 text-lg leading-relaxed">
                    {service.description}
                  </p>
                  <button
                      onClick={() => {
                        const nextSection = document.getElementById(`service-${index + 1}`);
                        if (nextSection) {
                          nextSection.scrollIntoView({ behavior: "smooth" });
                        } else {
                          const footer = document.getElementById("footer");
                          if (footer) {
                            footer.scrollIntoView({ behavior: "smooth" });
                          }
                        }
                      }}
                      className={`w-48 py-2 rounded-full font-semibold transition-colors duration-300 
                        border-2 ${
                          service.bgColor.includes("teal")
                            ? "bg-white text-teal-500 border-white hover:bg-teal-600 hover:text-white"
                            : ""
                        } 
                        ${
                          service.bgColor.includes("pink")
                            ? "bg-white text-pink-500 border-white hover:bg-pink-600 hover:text-white"
                            : ""
                        }`}
                    >
                    CONTINUE READING
                  </button>


              </div>
            </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* About us Section */}
    <section id="about" className="py-32">
  <div className="container mx-auto px-6 text-center">
    <h3 className="text-5xl font-bold text-gray-800 mb-12">About Us</h3>

    {/* Large Centered Logo */}
    <div className="flex justify-center mb-10">
      <img
        src="logo-picture.png"
        alt="Company Logo"
        className="w-64 h-auto md:w-[28rem]" // 👈 bigger logo (256px–320px wide)
      />
    </div>

    {/* Description */}
    <p className="max-w-2xl mx-auto text-gray-600 text-2xl leading-relaxed">
    Experience Travel Like Never Before,
    Chezher 888 Travel & Tours is your go-to platform for seamless and hassle-free travel bookings. We empower transportation providers to offer smooth, reliable, and comfortable journeys while giving travelers a simple way to plan their trips with confidence. From start to finish, we handle the details so every journey feels effortless. Discover convenience, comfort, and unforgettable experiences, your next adventure starts here!
    </p>
  </div>
</section>

    {/* The new carousel section */}
    <section id="gallery" className="w-full">
      <ImageCarousel images={carouselImages} />
    </section>

    <section id="contact" className="py-32 bg-gray-100 relative">
  <div className="container mx-auto px-6 text-center">
    <h3 className="text-5xl font-bold text-gray-800 mb-8">Contact Us</h3>
    <p className="max-w-4xl mx-auto text-gray-600 mb-12">
      Have questions? Feel free to reach out to us directly via email or phone, or visit us at our office.
    </p>

    {/* Map wrapper */}
    <div className="relative w-full max-w-6xl mx-auto h-[600px] rounded-lg shadow-xl overflow-hidden">
      <iframe
        title="Google Maps Location"
        className="w-full h-full border-0"
        loading="lazy"
        allowFullScreen=""
        referrerPolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps/embed?pb=!1m15!1m11!1m3!1d1491.4782648078294!2d120.9719386623056!3d14.44238689293021!2m2!1f0!2f0!3m2!1i1024!2i768!4f13.1!2m1!1s353-D%20Molino%20road%20%2C%20Brgy%20Molino%203%20Bacoor%20Cavite!5e1!3m2!1sen!2sph!4v1757396211879!5m2!1sen!2sph"
      ></iframe>

      {/* Floating contact card */}
        <div
          className="
            absolute 
            md:top-1/2 md:right-6 md:transform md:-translate-y-1/2 
            top-4 right-4
            bg-white 
            p-4 md:p-8 
            w-[220px] md:w-[350px] 
            rounded-lg shadow-2xl text-left
          "
        >
          <h4 className="text-lg md:text-2xl font-semibold mb-4 md:mb-6 text-gray-800">
            Get in Touch
          </h4>

          <div className="mb-3 md:mb-4 text-sm md:text-base">
            <h5 className="font-bold text-gray-700">Email Address:</h5>
            <a
              href="mailto:chezhertours@gmail.com"
              className="text-green-500 hover:underline break-words"
            >
              chezhertours@gmail.com
            </a>
          </div>

          <div className="mb-3 md:mb-4 text-sm md:text-base">
            <h5 className="font-bold text-gray-700">Phone Number:</h5>
            <p>Globe:</p>
            <a href="tel:+639756256980" className="text-green-500 hover:underline">
              0975-625-6980
            </a>
            <p>Smart:</p>
            <a href="tel:+639994809718" className="text-green-500 hover:underline">
              0999-480-9718
            </a>
          </div>

          <div className="text-sm md:text-base">
            <h5 className="font-bold text-gray-700">Location:</h5>
            <p>353-D Molino road , Brgy Molino 3 Bacoor Cavite</p>
          </div>
        </div>

    </div>
  </div>
</section>

  </>
);

const BookingModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    destination: "",
    passengers: "1",
    date: "",
    specificArea: "",
    message: "",
  });

  const [showSpecificAreaInput, setShowSpecificAreaInput] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const destinations = [
    "Manila City tour",
    "Laguna tour, pagsanjan falls visit , caliraya resort",
    "Subic tour",
    "Baguio tour",
    "Bicol region tour",
    "Ilocos sur tour",
    "Ilocos norte tour",
    "Banaue rice terraces",
    "Sagada Tour",
  ];

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const filtered = value.replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, [name]: filtered }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "destination" && value === "Quezon City") {
      setShowSpecificAreaInput(true);
    } else if (name === "destination" && value !== "Quezon City") {
      setShowSpecificAreaInput(false);
      setFormData((prev) => ({ ...prev, specificArea: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bookings`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        const data = await res.json();

        if (data.success && data.pdfBase64) {
          // Convert base64 to blob
          const byteCharacters = atob(data.pdfBase64);
          const byteNumbers = new Array(byteCharacters.length)
            .fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });

          // Trigger download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `booking-${Date.now()}.pdf`;
          link.click();
          URL.revokeObjectURL(link.href);
        }

        setFormData({
          name: "",
          email: "",
          phone: "",
          destination: "",
          passengers: "1",
          date: "",
          specificArea: "",
          message: "",
        });
        setSuccess(true);
      } else {
        alert("Failed to submit booking. Check console for details.");
      }
    } catch (error) {
      console.error("Error submitting booking:", error);
      alert("Something went wrong. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-50 overflow-auto bg-gray-900 bg-opacity-50 flex items-center justify-center">
        <div className="bg-white rounded-lg p-8 m-4 w-11/12 max-w-5xl mx-auto shadow-lg relative max-h-[90vh] overflow-y-auto lg:max-h-full lg:overflow-y-visible">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
          >
            ✕
          </button>

          <h4 className="text-2xl font-bold mb-4">Book Your Trip</h4>
          <p className="text-gray-600 mb-4">
            Fill out the form to get a personalized quote.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
              />
            </div>

            <div className="mb-4">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
              />
            </div>

            <div className="mb-4">
              <label>Phone (Philippine number)</label>
              <input
                type="text"
                name="phone"
                placeholder="09XXXXXXXXX"
                value={formData.phone}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border rounded-lg"
                maxLength={11}
                required
              />
            </div>

            <div className="mb-4">
              <label>Destination</label>
              <select
                name="destination"
                value={formData.destination}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
              >
                <option value="" disabled>Select a destination</option>
                {destinations.map((dest, idx) => (
                  <option key={idx} value={dest}>{dest}</option>
                ))}
              </select>
            </div>

            {showSpecificAreaInput && (
              <div className="mb-4">
                <label>Specific Area</label>
                <input
                  type="text"
                  name="specificArea"
                  value={formData.specificArea}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>
            )}

            <div className="mb-4">
              <label>Number of Passengers</label>
              <select
                name="passengers"
                value={formData.passengers}
                onChange={handleInputChange}
                className="px-4 py-2 border rounded-lg w-[6rem]"
              >
                {Array.from({ length: 50 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
            </div>

             {/* Date Selection */}
            <div className="mb-4">
              <label>Select Date</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
              />
            </div>

            <div className="mb-4">
              <label>Message</label>
              <textarea
                placeholder="Please provide details about your query"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border rounded-lg"
                rows="4"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Submit Booking"}
            </button>
          </form>
        </div>
      </div>

      {success && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-8 w-96 flex flex-col items-center text-center shadow-lg relative">
            ✔
            <h3 className="text-2xl font-bold mb-2">Successfully Booked!</h3>
            <p className="text-gray-600 mb-6">
              Your booking has been submitted.
            </p>
            <button
              onClick={() => { setSuccess(false); onClose(); }}
              className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};



const ImageCarousel = ({ images }) => {
  const sliderRef = useRef(null);
  const animationRef = useRef(null);
  const positionRef = useRef(0);
  const speedRef = useRef(0.3); // continuous scroll speed
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const animate = () => {
      if (!isPaused) {
        positionRef.current -= speedRef.current;
        if (Math.abs(positionRef.current) >= slider.scrollWidth / 2) {
          positionRef.current = 0;
        }
        slider.style.transform = `translateX(${positionRef.current}px)`;
      }
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current);
  }, [isPaused]);

  const pauseAndResume = () => {
    setIsPaused(true);
    setTimeout(() => setIsPaused(false), 3000); // resume after 3s
  };

  const slideManually = (direction) => {
    const slider = sliderRef.current;
    if (!slider) return;

    pauseAndResume();

    // detect screen size → adjust images per view
    const imagesPerView = window.innerWidth < 768 ? 2 : 4;
    const imageWidth = slider.scrollWidth / (images.length * 2); // width of 1 image
    const moveBy = imageWidth * 2; // always move 2 images

    // add smooth transition
    slider.style.transition = "transform 1.5s ease-in-out";
    positionRef.current += direction * moveBy;
    slider.style.transform = `translateX(${positionRef.current}px)`;

    setTimeout(() => {
      slider.style.transition = "";
    }, 1500);
  };

  const handleNext = () => slideManually(-1);
  const handlePrev = () => slideManually(1);

  const duplicatedImages = [...images, ...images];

  return (
    <div className="relative w-full overflow-hidden">
      <div
        ref={sliderRef}
        className="flex"
        style={{
          whiteSpace: "nowrap",
          willChange: "transform",
        }}
      >
        {duplicatedImages.map((img, i) => (
          <div
            key={i}
            className="w-1/2 md:w-1/4 flex-shrink-0 px-2"
          >
            <div className="w-full h-[220px] md:h-[400px]">
              <img
                src={img}
                alt={`carousel-img-${i}`}
                className="w-full h-full object-contain md:object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Buttons centered below */}
      <div className="flex justify-center gap-6 mt-6">
        <button
          onClick={handlePrev}
          className="p-3 rounded-full bg-black bg-opacity-50 text-white hover:bg-opacity-75 transition-all"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={handleNext}
          className="p-3 rounded-full bg-black bg-opacity-50 text-white hover:bg-opacity-75 transition-all"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

// Example usage
const carouselImages = [crs1, crs2, crs3, crs5, img11, img4, img7, img8, img9, img10];








// Define the Footer component
const Footer = () => (
    <footer className="bg-gray-800 text-gray-200">
      <div className="container mx-auto py-10 px-6 flex flex-col md:flex-row justify-between items-center">
        <p>© {new Date().getFullYear()} Chezher 888 Travel & Tours Inc. All rights reserved.</p>
        <div className="space-x-4 mt-4 md:mt-0 flex">
          {/* Social media links with raw SVGs (equivalent to lucide-react) */}
          <a href="" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-instagram"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
          </a>
          <a href="" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-white transition-colors duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-twitter"><path d="M22.254 5.922c-.781.347-1.616.58-2.482.69a4.896 4.896 0 0 0 2.147-2.383c-.902.535-1.902.923-2.956 1.144A4.908 4.908 0 0 0 12.003 4c-2.7 0-4.9 2.2-4.9 4.9 0 .385.045.76.132 1.12C5.008 10.15 2.686 8.87 1.09 6.94a4.912 4.912 0 0 0-.665 2.44c0 1.7.86 3.197 2.17 4.062a4.877 4.877 0 0 1-2.22-.614v.06c0 2.378 1.693 4.364 3.93 4.82a4.93 4.93 0 0 1-2.215.084c.624 1.954 2.43 3.385 4.568 3.424A9.854 9.854 0 0 1 2 20.25a9.854 9.854 0 0 1-2-.132c2.186 1.4 4.78 2.21 7.55 2.21 9.06 0 14.02-7.5 14.02-14.02a9.924 9.924 0 0 0 .25-2.27z"/></svg>
          </a>
          <a href="https://www.facebook.com/profile.php?id=100084568578953" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-white transition-colors duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
          </a>
          <a href="" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-white transition-colors duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-tiktok"><path d="M9 13v6a2 2 0 0 1-2 2H5V13a9 9 0 0 1 9-9h2v8h-2c-1.657 0-3 1.343-3 3z"/></svg>
          </a>
          <a href="" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="hover:text-white transition-colors duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-youtube"><path d="M2.5 17.5c-1.4 0-2.5-1.1-2.5-2.5v-7c0-1.4 1.1-2.5 2.5-2.5h19c1.4 0 2.5 1.1 2.5 2.5v7c0 1.4-1.1 2.5-2.5 2.5H2.5z"/><path d="M10 8l6 4-6 4z"/></svg>
          </a>
        </div>
      </div>
    </footer>
);

export default App;